import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Form } from "react-formio";
import { getParticipantSurveyResponse } from "../../Utils/adminFunctions";
import { ToastContainer, toast } from "react-toastify";

let AdminParticipantSurveyResponse = () => {
  const { surveyID } = useParams();
  const { participantID } = useParams();

  const [surveyName, setSurveyName] = useState("");
  const [formJson, setFormJson] = useState([]);
  const [dataJson, setDataJson] = useState([]);
  const [companyLogo, setCompanyLogo] = useState("");
  useEffect(() => {
    async function fetchAPI1() {
      const response = await getParticipantSurveyResponse(
        surveyID,
        participantID
      );
      if (response.status == "success") {
        setSurveyName(response.getSurveyName);
        setCompanyLogo(response.getCompanyLogo);
        const formJSON = JSON.parse(response.getFormJson)?.map(( item,index )=> {
          if(item.label?.toLowerCase() !== "submit"){
            return ({...item, label:`${index+1}. ${item.label}`})
          } else return item
        })
        setFormJson(formJSON);
        setDataJson(JSON.parse(response.getDataJson));
      } else {
        toast.error(response.message, { autoClose: 1500 });
      }
    }
    fetchAPI1();
  }, []);

  return (
    <div>
      <ToastContainer></ToastContainer>
      <div className="container-fluid custom-container-fluid-background-survey">
        <div className="survey-header">
          <div className="row">
            <div className="offset-md-1 col-md-10 offset-md-1">
              <div className="form-box rounded-0">
                <center>
                  <img
                    src={companyLogo}
                    alt="image not available"
                    height={35}
                  ></img>
                </center>
                <br></br>
                <center>
                  {" "}
                  <h6>
                    <b>{surveyName}</b>
                  </h6>
                </center>
              </div>
            </div>

            <div className="offset-md-1 col-md-10 offset-md-1">
              <div className="action-button-view-page form-view-action">
                <Link
                  to={"/AdminListResponses/" + surveyID}
                  className="btn btn-sm custom-btn-primary pull-right"
                >
                  <i className="fa fa-arrow-left"></i> Back
                </Link>
              </div>
            </div>
          </div>
          <div className="row form-box-top-margin">
            <div className="offset-md-1 col-md-10 offset-md-1">
              <div className="form-box">
                <Form
                  src={{
                    display: "form",
                    components: formJson,
                  }}
                  submission={{
                    data: dataJson,
                  }}
                  options={{ readOnly: true }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminParticipantSurveyResponse;
